export default __webpack_public_path__ + "static/media/shape.799c5376.svg";